// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"8172cc32","110":"348177be","177":"bd971dde","191":"94b94ccd","305":"8d79251d","615":"d6c4be95","737":"aa6ca178","818":"750e6cd7","919":"8277ef30"}[chunkId] + ".chunk.js";
};